import PublisherContainers from '../../../../actions/PublisherContainers';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import CustomNotify from "../../../Notify";

export const actions = {
    getContainers(state, actionType) {
        const params = {
            ...query.parseToSend(state),
            ...removeParams(),
            q: state.nameLink,
            offer_ids: Number(state.offerId) || state.offer_ids
        };

        PublisherContainers.getContainres(params);
    },

    getLocales(state) {
        PublisherContainers.getLocales({
            offer_ids: state.offerId
        });
    },

    saveContainersPresets(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            publisher_id: state.publisherId,
            offer_id: state.offer.id,
            link_id: state.currentLink.id,
            params: JSON.stringify(state.container.params)
        };

        PublisherContainers.saveContainersPresets(params).then(data => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};
